import React from 'react';
import { Icon } from '../../../../../../components';
import { ContainerInput, Label, ShowCount } from './styles';
import { useValidation } from './useValidation';

interface IinputMoney {
  value: string;
  name: string;
  placeholder?: string;
  nameLabel: string;
  maxLength?: number;
  showCount?: boolean;
  setFieldError: ({ name, value }: any) => void;
  setFieldValue: ({ name, value }: any) => void;
  validateOnStart?: boolean;
  validateForm: number;
}

const InputMoney = (props: IinputMoney) => {
  const {
    value,
    name,
    placeholder,
    nameLabel,
    maxLength,
    showCount,
    setFieldError,
    setFieldValue,
    validateOnStart,
    validateForm
  } = props;

  const { errorText, setValue } = useValidation({
    maxLength,
    value,
    validateOnStart,
    validateForm,
    setFieldError,
    setFieldValue,
    name,
    isRequired: true
  });

  function formatNumber(n: string) {
    return new Intl.NumberFormat('en-US').format(Number(n.replace(/\D/g, '')));
  }

  return (
    <ContainerInput
      style={{ margin: '0 0 16px 0' }}
      data-testid="bse-form-inputMoney"
    >
      {nameLabel && <Label color="#161d1f"> {nameLabel} </Label>}
      <input
        data-testid="bse-form-inputMoney-input"
        autoComplete="off"
        value={value ? `S/. ${formatNumber(value)}` : ''}
        type="text"
        name={name}
        className={`${value ? 'inputFilled' : ''} ${
          errorText ? 'inputError' : ''
        }`}
        onChange={(e: any) => {
          setValue(
            `S/ ${e.target.value}`
              .replace(/[^0-9.]/g, '')
              .replace(/(\..*)\./g, '$1')
              .replace(/\./g, '')
          );
        }}
        // onChange={handleChange}
        placeholder={placeholder}
      />
      {showCount && (
        <ShowCount error={errorText}>
          {errorText && (
            <div className="errorText">
              <Icon name="alert-triangle" size={12} />
              {errorText}
            </div>
          )}
          {errorText === 'Dato pendiente' ? (
            ''
          ) : (
            <div>
              {value?.length ?? 0} / {maxLength}
            </div>
          )}
        </ShowCount>
      )}
    </ContainerInput>
  );
};

InputMoney.defaultProps = {
  maxLength: 30,
  placeholder: 'Ingresar monto en soles (S/.)',
  showCount: true,
  validateOnStart: false
};

export default InputMoney;
